<div class="section-main-card">
  <header>
    <ng-container [ngSwitch]="headingLevel">
      <h2 *ngSwitchCase="2">
        {{ card.diagnosis_title }} versus {{ card.differential_title }}
      </h2>
      <h3 *ngSwitchCase="3">
        {{ card.diagnosis_title }} versus {{ card.differential_title }}
      </h3>
      <h4 *ngSwitchDefault>
        {{ card.diagnosis_title }} versus {{ card.differential_title }}
      </h4>
    </ng-container>
  </header>

  <div class="ddx-table-wrapper">
    <table class="ddx-table">
      <thead>
        <tr>
          <th class="ddx-col-left">{{ card.diagnosis_title }}</th>
          <th class="ddx-col-right">{{ card.differential_title }}</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let pair of card.pairs">
          <td class="ddx-col-left" [innerHTML]="pair.diagnosis_formatted | markdown"></td>
          <td class="ddx-col-right" [innerHTML]="pair.differential_formatted | markdown"></td>
        </tr>
      </tbody>
    </table>
  </div>
</div>
